export default {
  name: 'ScIconNavBar',
};
